export enum AnnouncementType {
  DesignGen = 'announcementDesignGen',
}
